import React, { useState } from 'react';
// noinspection ES6CheckImport
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import firebase from '../../../config/firebase';
import 'firebase/auth';

import Header from '../../molecules/Header';
// import NavBar from "../../molecules/NavBar";
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';

import * as S from './styles';

function PasswordReset() {
  const [email, setEmail] = useState();
  const [msg, setMsg] = useState();

  function sendPasswordResetEmail() {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((result) => {
        setMsg('Enviamos um link para você redefinir sua senha para seu e-mail');
      })
      .catch((err) => {
        setMsg('Verifique se o e-mail está correto');
      });
  }

  return (
    <S.Container>
      {useSelector((state) => state.auth.user_logged_in) > 0 ? <Redirect to="/#top" /> : null}
      <Header />
      <MainContent>
        <div className="signup-form-holder">
          <form className="signup-form">
            <div className="email-form">
              Digite seu e-mail
              <input onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" />
            </div>

            {msg}

            <div className="login-btn">
              <button onClick={sendPasswordResetEmail} type="button">
                Recuperar Senha
              </button>
            </div>
          </form>
        </div>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default PasswordReset;
